import reveal from './reveal';
import timepicker from  './classes-events/jquery.timepicker.min.js'
require('jquery-migrate');
//require('webpack-jquery-ui');
require('jquery-ui/ui/widgets/datepicker.js');
const $ = require('jquery');

global.reveal = reveal;
global.$ = global.jQuery = $;
global.timepicker = timepicker;

function initNavigation(navItem) {
    navItem = $(navItem);
    
    navItem.each(function(){
        let item = $(this);
        let navDropdown = item.find('.nav__dropdown');
        let dropdownexists = (navDropdown.length) ? true : false;
        
        if(dropdownexists === true) {
            item.children('a').append('<span class="far fa-chevron-down nav__arrow"></span>').attr('data-reveal-type', 'slide');
            reveal.initReveal(item.children('a'), navDropdown, '', false);
        } else {
        }
    });

    $('.js-mob-menu-trigger').on('click', function (e) {
        e.preventDefault();
        $('.header').toggleClass('is-active');
        $('body').toggleClass('no-scroll');
    });
}



function initSearch(trigger, search, close) {
    trigger = $(trigger);
    search = $(search);
    close = $(close);
    var formField = search.find('.form__input').first();
    var backdrop = '<div class="form--flyout__backdrop js-backdrop"></div>';
    
    trigger
        .attr({
            'role': 'button',
            'aria-expanded': 'false',
        });

    search
        .attr({
            'aria-hidden': 'true',
        }).find('.form__input, .form__submit').attr({
            'tabindex': '-1',
        });
    
    var toggleFocus = function(formField) {
        if(formField.hasClass('is-focused')) {
            formField.focus();
        } else {
            formField.blur();
        }
    };
    
    var toggleAttr = function(trigger, search) {
        if (trigger.hasClass('is-active')) {
            trigger.attr( 'aria-expanded', 'false');
        } else {
            trigger.attr( 'aria-expanded', 'true');
        }
        
        if (search.hasClass('is-active')) {
            search.attr({ 
                'aria-hidden': 'false',
            }).find('.form__input, .form__submit').attr({
                'tabindex': '0',
            });
        } else {
            search.attr({ 
                'aria-hidden': 'true',
            }).find('.form__input, .form__submit').attr({
                'tabindex': '-1',
            });
        }
    }
    
    var closeSearch = function() {
        trigger.removeClass('is-active');
        search.removeClass('is-active'); 
        formField.removeClass('is-focused');
        $('.js-backdrop').fadeOut().detach();
        
        toggleFocus(formField);
        toggleAttr(trigger, search);
    }
    
    trigger.on("click", function(e){
        e.preventDefault();
        $(this).toggleClass('is-active');
        search.toggleClass('is-active'); 
        formField.toggleClass('is-focused');
        $('body').append(backdrop);
        
        toggleFocus(formField);
        toggleAttr($(this), search);
    });
    
    close.on("click", function(e){
        e.preventDefault();
        closeSearch();
    });
    
    $(document).on('click', '.js-backdrop', function(e){
        e.preventDefault();
        closeSearch();
    });
}

if($('.js-action-trigger').length) {
    $('.js-action-trigger').each(function(){
        let flyOut = $(this);
        reveal.initReveal(flyOut, flyOut.next('.js-action-flyout'), '', false);
    });
}

$(document).ready(function () {
    initNavigation('.js-nav-item');
    initSearch('.js-toggle-search', '.js-search-form', '.js-close-search');
    
    $('.js-flyout-trigger').each(function(){
        let flyOut = $(this);
        reveal.initReveal(flyOut, flyOut.next('.js-flyout'), '', false);
    });
    
    $('.js-accordion-trigger').each(function(){
        let accordion = $(this);
        reveal.initReveal(accordion, accordion.next('.js-accordion-content'), '', false);
    });
    
    $('.js-formbuilder-trigger').each(function(){
        let trigger = $(this);
        initSearch(trigger, '.js-formbuilder-flyout', '.js-close-flyout');
    });
    
    // get current URL path and assign 'active' class
	var pathname = window.location.pathname;
    var parentItem = $('.nav__item > a[href="'+pathname+'"]').parent();
	parentItem.addClass('is-current');
    if($('.nav__item > a[href="'+pathname+'"]').closest('.js-nav-item').length) {
        $('.nav__item > a[href="'+pathname+'"]').closest('.js-nav-item').children('a').click();
    }
    
    // This is for campaigns
    if(window.location.href.indexOf("CampaignPageItemsEdit.aspx") > -1) {
        $('option[value=services]').hide();
        $('option[value=events]').hide();
        $('option[value=mapsearch]').hide();
        $('option[value=servcies]').hide();
        $('option[value=tabs]').hide();
        $('option[value=video]').text('Video Slider');

        $(".hasDatePicker").datepicker();
        // Return a helper with preserved width of cells  
        var fixHelper = function (e, ui) {
            ui.children().each(function () {
                $(this).width($(this).width());
            });
            return ui;
        };

        $('.tbl-items tbody').sortable({
            handle: 'td:first i',
            helper: fixHelper,
            stop: function (event, ui) {
                $('#pnlWeightButtons').show();

                var strWeight = '';
                $('#gvCampaignItems tbody tr').each(function (index) {
                    var hdnField = $(this).find('input[type="hidden"]');
                    if (hdnField && hdnField.length > 0) {
                        var itemId = $(hdnField).val();
                        strWeight += itemId + "," + index + ';';
                    }
                });
                $('#hdnUpdatedWeight').val(strWeight);
                var updated = $('#hdn-items-updated');
                if (updated && updated.length > 0) {
                    $(updated).val('true').trigger('change');
                }
            }
        });

        $('.tbl-tabs tbody').sortable({
            handle: 'td:first i',
            helper: fixHelper,
            stop: function (event, ui) {
                var strWeight = '';
                $('#gvTabList tbody tr').each(function (index) {
                    var hdnField = $(this).find('input[type="hidden"]');
                    if (hdnField && hdnField.length > 0) {
                        var itemId = $(hdnField).val();
                        strWeight += itemId + "," + index + ';';
                    }
                });
                $('#hdnTabWeight').val(strWeight);
                var updated = $('#hdn-items-updated');
                if (updated && updated.length > 0) {
                    $(updated).val('true').trigger('change');
                }
            }
        });

        $('#tabcolor').on('change', function () {
            var hdnTabColor = $('#hdnTabColor');
            if (hdnTabColor && hdnTabColor.length > 0) {
                $(hdnTabColor).val($(this).val());
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/js/app.js